import { Component, OnInit } from '@angular/core';
import { EventService } from '@reenstudio/app/core/services/event-service';

@Component({
  selector: 'app-incentive-dashboard',
  templateUrl: './incentive-dashboard.component.html',
  styleUrls: ['./incentive-dashboard.component.scss'],
})
export class IncentiveDashboardComponent implements OnInit {
  ngOnInit(): void {
    EventService.changeCer.subscribe(() => {
      this.ngOnInit();
    });

    EventService.changeSite.subscribe(() => {
      this.ngOnInit();
    });
  }
}
